/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Stoeckl Execution Center API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AppConfig,
  ApproveRunInputInput,
  AssetUploadError,
  AuditEventsPage,
  CreateRunInputInput,
  CreateUserInputInput,
  FortyToolsWebhookAck,
  Health,
  HttpError,
  JoinRequest,
  ListAuditEventsParams,
  ListRunsParams,
  ListUsersParams,
  PlandWebhookAck,
  RejectRunInputInput,
  Run,
  RunsPage,
  UpdateConfigInputInput,
  UpdateRunInputInput,
  UpdateUserInputInput,
  User,
  UsersPage,
  VerifyWhatsAppWebhookParams,
  WhatsAppWebhookAck
} from './model';

import { customFetch } from '../http-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetAssetUrl = (id: string,) => {


  

  return `/api/assets/${id}`
}

export const getAsset = async (id: string, options?: RequestInit): Promise<void> => {
  
  return customFetch<void>(getGetAssetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAssetQueryKey = (id: string,) => {
    return [
    `/api/assets/${id}`
    ] as const;
    }

    
export const getGetAssetQueryOptions = <TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({ signal }) => getAsset(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getAsset>>>
export type GetAssetQueryError = unknown


export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getGetAssetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({ signal }) => getAsset(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAsset>>>
export type GetAssetSuspenseQueryError = unknown


export function useGetAssetSuspense<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetSuspense<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetSuspense<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAssetSuspense<TData = Awaited<ReturnType<typeof getAsset>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getListAuditEventsUrl = (params: ListAuditEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-events?${stringifiedParams}` : `/api/audit-events`
}

export const listAuditEvents = async (params: ListAuditEventsParams, options?: RequestInit): Promise<AuditEventsPage> => {
  
  return customFetch<AuditEventsPage>(getListAuditEventsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListAuditEventsQueryKey = (params?: ListAuditEventsParams,) => {
    return [
    `/api/audit-events`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListAuditEventsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(params: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditEvents>>> = ({ signal }) => listAuditEvents(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditEvents>>>
export type ListAuditEventsQueryError = HttpError


export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof listAuditEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof listAuditEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAuditEvents<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getListAuditEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(params: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditEvents>>> = ({ signal }) => listAuditEvents(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditEvents>>>
export type ListAuditEventsSuspenseQueryError = HttpError


export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAuditEventsSuspense<TData = Awaited<ReturnType<typeof listAuditEvents>>, TError = HttpError>(
 params: ListAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditEventsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getGetConfigUrl = () => {


  

  return `/api/config`
}

export const getConfig = async ( options?: RequestInit): Promise<AppConfig> => {
  
  return customFetch<AppConfig>(getGetConfigUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetConfigQueryKey = () => {
    return [
    `/api/config`
    ] as const;
    }

    
export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = HttpError


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getGetConfigSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigSuspenseQueryError = HttpError


export function useGetConfigSuspense<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigSuspense<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigSuspense<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConfigSuspense<TData = Awaited<ReturnType<typeof getConfig>>, TError = HttpError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getUpdateConfigUrl = () => {


  

  return `/api/config`
}

export const updateConfig = async (updateConfigInputInput: UpdateConfigInputInput, options?: RequestInit): Promise<AppConfig> => {
  
  return customFetch<AppConfig>(getUpdateConfigUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateConfigInputInput,)
  }
);}
  



export const getUpdateConfigMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: UpdateConfigInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: UpdateConfigInputInput}, TContext> => {

const mutationKey = ['updateConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfig>>, {data: UpdateConfigInputInput}> = (props) => {
          const {data} = props ?? {};

          return  updateConfig(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfig>>>
    export type UpdateConfigMutationBody = UpdateConfigInputInput
    export type UpdateConfigMutationError = HttpError

    export const useUpdateConfig = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: UpdateConfigInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConfig>>,
        TError,
        {data: UpdateConfigInputInput},
        TContext
      > => {
      return useMutation(getUpdateConfigMutationOptions(options), queryClient);
    }
    
export const getUploadConfigImageUrl = () => {


  

  return `/api/config/image`
}

export const uploadConfigImage = async ( options?: RequestInit): Promise<AppConfig> => {
  
  return customFetch<AppConfig>(getUploadConfigImageUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getUploadConfigImageMutationOptions = <TError = AssetUploadError | HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConfigImage>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadConfigImage>>, TError,void, TContext> => {

const mutationKey = ['uploadConfigImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadConfigImage>>, void> = () => {
          

          return  uploadConfigImage(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UploadConfigImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadConfigImage>>>
    
    export type UploadConfigImageMutationError = AssetUploadError | HttpError

    export const useUploadConfigImage = <TError = AssetUploadError | HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConfigImage>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadConfigImage>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUploadConfigImageMutationOptions(options), queryClient);
    }
    
export const getGetHealthUrl = () => {


  

  return `/api/health`
}

export const getHealth = async ( options?: RequestInit): Promise<Health> => {
  
  return customFetch<Health>(getGetHealthUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetHealthQueryKey = () => {
    return [
    `/api/health`
    ] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getGetHealthSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthSuspenseQueryError = unknown


export function useGetHealthSuspense<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthSuspense<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealthSuspense<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHealthSuspense<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getApproveJoinRequestUrl = (requestId: string,) => {


  

  return `/api/join-requests/${requestId}/approve`
}

export const approveJoinRequest = async (requestId: string, options?: RequestInit): Promise<JoinRequest> => {
  
  return customFetch<JoinRequest>(getApproveJoinRequestUrl(requestId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getApproveJoinRequestMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveJoinRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveJoinRequest>>, TError,{requestId: string}, TContext> => {

const mutationKey = ['approveJoinRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveJoinRequest>>, {requestId: string}> = (props) => {
          const {requestId} = props ?? {};

          return  approveJoinRequest(requestId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveJoinRequest>>>
    
    export type ApproveJoinRequestMutationError = HttpError

    export const useApproveJoinRequest = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveJoinRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveJoinRequest>>,
        TError,
        {requestId: string},
        TContext
      > => {
      return useMutation(getApproveJoinRequestMutationOptions(options), queryClient);
    }
    
export const getRejectJoinRequestUrl = (requestId: string,) => {


  

  return `/api/join-requests/${requestId}/reject`
}

export const rejectJoinRequest = async (requestId: string, options?: RequestInit): Promise<JoinRequest> => {
  
  return customFetch<JoinRequest>(getRejectJoinRequestUrl(requestId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getRejectJoinRequestMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJoinRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectJoinRequest>>, TError,{requestId: string}, TContext> => {

const mutationKey = ['rejectJoinRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectJoinRequest>>, {requestId: string}> = (props) => {
          const {requestId} = props ?? {};

          return  rejectJoinRequest(requestId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RejectJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof rejectJoinRequest>>>
    
    export type RejectJoinRequestMutationError = HttpError

    export const useRejectJoinRequest = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJoinRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectJoinRequest>>,
        TError,
        {requestId: string},
        TContext
      > => {
      return useMutation(getRejectJoinRequestMutationOptions(options), queryClient);
    }
    
export const getCreateRunUrl = () => {


  

  return `/api/runs`
}

export const createRun = async (createRunInputInput: CreateRunInputInput, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getCreateRunUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRunInputInput,)
  }
);}
  



export const getCreateRunMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRun>>, TError,{data: CreateRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRun>>, TError,{data: CreateRunInputInput}, TContext> => {

const mutationKey = ['createRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRun>>, {data: CreateRunInputInput}> = (props) => {
          const {data} = props ?? {};

          return  createRun(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRunMutationResult = NonNullable<Awaited<ReturnType<typeof createRun>>>
    export type CreateRunMutationBody = CreateRunInputInput
    export type CreateRunMutationError = HttpError

    export const useCreateRun = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRun>>, TError,{data: CreateRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRun>>,
        TError,
        {data: CreateRunInputInput},
        TContext
      > => {
      return useMutation(getCreateRunMutationOptions(options), queryClient);
    }
    
export const getListRunsUrl = (params?: ListRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runs?${stringifiedParams}` : `/api/runs`
}

export const listRuns = async (params?: ListRunsParams, options?: RequestInit): Promise<RunsPage> => {
  
  return customFetch<RunsPage>(getListRunsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListRunsQueryKey = (params?: ListRunsParams,) => {
    return [
    `/api/runs`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListRunsQueryOptions = <TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(params?: ListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRuns>>> = ({ signal }) => listRuns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listRuns>>>
export type ListRunsQueryError = HttpError


export function useListRuns<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params: undefined |  ListRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRuns<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRuns<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRuns<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getListRunsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(params?: ListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRuns>>> = ({ signal }) => listRuns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRunsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listRuns>>>
export type ListRunsSuspenseQueryError = HttpError


export function useListRunsSuspense<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params: undefined |  ListRunsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRunsSuspense<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRunsSuspense<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRunsSuspense<TData = Awaited<ReturnType<typeof listRuns>>, TError = HttpError>(
 params?: ListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRunsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getGetRunUrl = (runId: string,) => {


  

  return `/api/runs/${runId}`
}

export const getRun = async (runId: string, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getGetRunUrl(runId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetRunQueryKey = (runId: string,) => {
    return [
    `/api/runs/${runId}`
    ] as const;
    }

    
export const getGetRunQueryOptions = <TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRun>>> = ({ signal }) => getRun(runId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunQueryResult = NonNullable<Awaited<ReturnType<typeof getRun>>>
export type GetRunQueryError = HttpError


export function useGetRun<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRun>>,
          TError,
          Awaited<ReturnType<typeof getRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRun<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRun>>,
          TError,
          Awaited<ReturnType<typeof getRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRun<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRun<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getGetRunSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRun>>> = ({ signal }) => getRun(runId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRun>>>
export type GetRunSuspenseQueryError = HttpError


export function useGetRunSuspense<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunSuspense<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunSuspense<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRunSuspense<TData = Awaited<ReturnType<typeof getRun>>, TError = HttpError>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunSuspenseQueryOptions(runId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getUpdateRunUrl = (runId: string,) => {


  

  return `/api/runs/${runId}`
}

export const updateRun = async (runId: string,
    updateRunInputInput: UpdateRunInputInput, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getUpdateRunUrl(runId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRunInputInput,)
  }
);}
  



export const getUpdateRunMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRun>>, TError,{runId: string;data: UpdateRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRun>>, TError,{runId: string;data: UpdateRunInputInput}, TContext> => {

const mutationKey = ['updateRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRun>>, {runId: string;data: UpdateRunInputInput}> = (props) => {
          const {runId,data} = props ?? {};

          return  updateRun(runId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRunMutationResult = NonNullable<Awaited<ReturnType<typeof updateRun>>>
    export type UpdateRunMutationBody = UpdateRunInputInput
    export type UpdateRunMutationError = HttpError

    export const useUpdateRun = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRun>>, TError,{runId: string;data: UpdateRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRun>>,
        TError,
        {runId: string;data: UpdateRunInputInput},
        TContext
      > => {
      return useMutation(getUpdateRunMutationOptions(options), queryClient);
    }
    
export const getApproveRunUrl = (runId: string,) => {


  

  return `/api/runs/${runId}/approve`
}

export const approveRun = async (runId: string,
    approveRunInputInput: ApproveRunInputInput, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getApproveRunUrl(runId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approveRunInputInput,)
  }
);}
  



export const getApproveRunMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRun>>, TError,{runId: string;data: ApproveRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveRun>>, TError,{runId: string;data: ApproveRunInputInput}, TContext> => {

const mutationKey = ['approveRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveRun>>, {runId: string;data: ApproveRunInputInput}> = (props) => {
          const {runId,data} = props ?? {};

          return  approveRun(runId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveRunMutationResult = NonNullable<Awaited<ReturnType<typeof approveRun>>>
    export type ApproveRunMutationBody = ApproveRunInputInput
    export type ApproveRunMutationError = HttpError

    export const useApproveRun = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRun>>, TError,{runId: string;data: ApproveRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveRun>>,
        TError,
        {runId: string;data: ApproveRunInputInput},
        TContext
      > => {
      return useMutation(getApproveRunMutationOptions(options), queryClient);
    }
    
export const getRejectRunUrl = (runId: string,) => {


  

  return `/api/runs/${runId}/reject`
}

export const rejectRun = async (runId: string,
    rejectRunInputInput: RejectRunInputInput, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getRejectRunUrl(runId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectRunInputInput,)
  }
);}
  



export const getRejectRunMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRun>>, TError,{runId: string;data: RejectRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectRun>>, TError,{runId: string;data: RejectRunInputInput}, TContext> => {

const mutationKey = ['rejectRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectRun>>, {runId: string;data: RejectRunInputInput}> = (props) => {
          const {runId,data} = props ?? {};

          return  rejectRun(runId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RejectRunMutationResult = NonNullable<Awaited<ReturnType<typeof rejectRun>>>
    export type RejectRunMutationBody = RejectRunInputInput
    export type RejectRunMutationError = HttpError

    export const useRejectRun = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRun>>, TError,{runId: string;data: RejectRunInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectRun>>,
        TError,
        {runId: string;data: RejectRunInputInput},
        TContext
      > => {
      return useMutation(getRejectRunMutationOptions(options), queryClient);
    }
    
export const getRetryRunUrl = (runId: string,) => {


  

  return `/api/runs/${runId}/retry`
}

export const retryRun = async (runId: string, options?: RequestInit): Promise<Run> => {
  
  return customFetch<Run>(getRetryRunUrl(runId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getRetryRunMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryRun>>, TError,{runId: string}, TContext> => {

const mutationKey = ['retryRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryRun>>, {runId: string}> = (props) => {
          const {runId} = props ?? {};

          return  retryRun(runId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RetryRunMutationResult = NonNullable<Awaited<ReturnType<typeof retryRun>>>
    
    export type RetryRunMutationError = HttpError

    export const useRetryRun = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryRun>>,
        TError,
        {runId: string},
        TContext
      > => {
      return useMutation(getRetryRunMutationOptions(options), queryClient);
    }
    
export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users?${stringifiedParams}` : `/api/users`
}

export const listUsers = async (params?: ListUsersParams, options?: RequestInit): Promise<UsersPage> => {
  
  return customFetch<UsersPage>(getListUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/api/users`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = HttpError


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getListUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersSuspenseQueryError = HttpError


export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUsersSuspense<TData = Awaited<ReturnType<typeof listUsers>>, TError = HttpError>(
 params?: ListUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getCreateUserUrl = () => {


  

  return `/api/users`
}

export const createUser = async (createUserInputInput: CreateUserInputInput, options?: RequestInit): Promise<User> => {
  
  return customFetch<User>(getCreateUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserInputInput,)
  }
);}
  



export const getCreateUserMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserInputInput}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserInputInput}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserInputInput
    export type CreateUserMutationError = HttpError

    export const useCreateUser = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserInputInput},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }
    
export const getGetUserUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const getUser = async (userId: string, options?: RequestInit): Promise<User> => {
  
  return customFetch<User>(getGetUserUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserQueryKey = (userId: string,) => {
    return [
    `/api/users/${userId}`
    ] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(userId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = HttpError


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(userId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserSuspenseQueryError = HttpError


export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = HttpError>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const getUpdateUserUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const updateUser = async (userId: string,
    updateUserInputInput: UpdateUserInputInput, options?: RequestInit): Promise<User> => {
  
  return customFetch<User>(getUpdateUserUrl(userId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserInputInput,)
  }
);}
  



export const getUpdateUserMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: UpdateUserInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: UpdateUserInputInput}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {userId: string;data: UpdateUserInputInput}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUser(userId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserInputInput
    export type UpdateUserMutationError = HttpError

    export const useUpdateUser = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: UpdateUserInputInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {userId: string;data: UpdateUserInputInput},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }
    
export const getDeleteUserUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const deleteUser = async (userId: string, options?: RequestInit): Promise<void> => {
  
  return customFetch<void>(getDeleteUserUrl(userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteUserMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUser(userId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = HttpError

    export const useDeleteUser = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }
    
/**
 * Receives FortyTools webhook deliveries. The registered URI is a capability URL (ADR-0013): possession of the token path segment is the credential; a mismatch answers 404 and an unset token answers 503. Deliveries are unsigned — there is no payload integrity and no replay protection; replay is neutralized by deduplication on the external reference. The body is the assumed delivery envelope `{ model, operation, data }`; deliveries that fail before mapping are acknowledged with 200 and visible in server logs only.
 * @summary FortyTools webhook (capability URL)
 */
export const getReceiveFortyToolsDeliveryUrl = (token: string,) => {


  

  return `/api/webhooks/fortytools/${token}`
}

export const receiveFortyToolsDelivery = async (token: string, options?: RequestInit): Promise<FortyToolsWebhookAck> => {
  
  return customFetch<FortyToolsWebhookAck>(getReceiveFortyToolsDeliveryUrl(token),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getReceiveFortyToolsDeliveryMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveFortyToolsDelivery>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveFortyToolsDelivery>>, TError,{token: string}, TContext> => {

const mutationKey = ['receiveFortyToolsDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveFortyToolsDelivery>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  receiveFortyToolsDelivery(token,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceiveFortyToolsDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof receiveFortyToolsDelivery>>>
    
    export type ReceiveFortyToolsDeliveryMutationError = HttpError

    /**
 * @summary FortyTools webhook (capability URL)
 */
export const useReceiveFortyToolsDelivery = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveFortyToolsDelivery>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receiveFortyToolsDelivery>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getReceiveFortyToolsDeliveryMutationOptions(options), queryClient);
    }
    
/**
 * Receives PlanD webhook deliveries. The registered URI is a capability URL (ADR-0013): possession of the token path segment is the credential; a mismatch answers 404 and an unset token answers 503. Deliveries are unsigned. Every authenticated delivery is persisted to the inbound-delivery inbox before any processing (ADR-0025): 200 means durably received, 5xx only when the insert itself fails. Processing is asynchronous, coalesced per property; its outcomes live on the inbox row and the audit trail, never in this response. The body is the assumed delivery envelope `{ entity, type, data }`.
 * @summary PlanD webhook (capability URL)
 */
export const getReceivePlandDeliveryUrl = (token: string,) => {


  

  return `/api/webhooks/pland/${token}`
}

export const receivePlandDelivery = async (token: string, options?: RequestInit): Promise<PlandWebhookAck> => {
  
  return customFetch<PlandWebhookAck>(getReceivePlandDeliveryUrl(token),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getReceivePlandDeliveryMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePlandDelivery>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receivePlandDelivery>>, TError,{token: string}, TContext> => {

const mutationKey = ['receivePlandDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receivePlandDelivery>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  receivePlandDelivery(token,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceivePlandDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof receivePlandDelivery>>>
    
    export type ReceivePlandDeliveryMutationError = HttpError

    /**
 * @summary PlanD webhook (capability URL)
 */
export const useReceivePlandDelivery = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePlandDelivery>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receivePlandDelivery>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getReceivePlandDeliveryMutationOptions(options), queryClient);
    }
    
/**
 * Answers Meta's subscription handshake (ADR-0015): a GET carrying hub.mode=subscribe and the matching hub.verify_token echoes hub.challenge verbatim as text/plain. A wrong token is rejected with 403; an unconfigured webhook answers 503.
 * @summary Meta webhook verification handshake
 */
export const getVerifyWhatsAppWebhookUrl = (params?: VerifyWhatsAppWebhookParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/webhooks/whatsapp?${stringifiedParams}` : `/api/webhooks/whatsapp`
}

export const verifyWhatsAppWebhook = async (params?: VerifyWhatsAppWebhookParams, options?: RequestInit): Promise<void> => {
  
  return customFetch<void>(getVerifyWhatsAppWebhookUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getVerifyWhatsAppWebhookQueryKey = (params?: VerifyWhatsAppWebhookParams,) => {
    return [
    `/api/webhooks/whatsapp`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getVerifyWhatsAppWebhookQueryOptions = <TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyWhatsAppWebhookQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>> = ({ signal }) => verifyWhatsAppWebhook(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerifyWhatsAppWebhookQueryResult = NonNullable<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>>
export type VerifyWhatsAppWebhookQueryError = unknown


export function useVerifyWhatsAppWebhook<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params: undefined |  VerifyWhatsAppWebhookParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyWhatsAppWebhook>>,
          TError,
          Awaited<ReturnType<typeof verifyWhatsAppWebhook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyWhatsAppWebhook<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyWhatsAppWebhook>>,
          TError,
          Awaited<ReturnType<typeof verifyWhatsAppWebhook>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyWhatsAppWebhook<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Meta webhook verification handshake
 */

export function useVerifyWhatsAppWebhook<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVerifyWhatsAppWebhookQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




export const getVerifyWhatsAppWebhookSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyWhatsAppWebhookQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>> = ({ signal }) => verifyWhatsAppWebhook(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerifyWhatsAppWebhookSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>>
export type VerifyWhatsAppWebhookSuspenseQueryError = unknown


export function useVerifyWhatsAppWebhookSuspense<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params: undefined |  VerifyWhatsAppWebhookParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyWhatsAppWebhookSuspense<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerifyWhatsAppWebhookSuspense<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Meta webhook verification handshake
 */

export function useVerifyWhatsAppWebhookSuspense<TData = Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError = unknown>(
 params?: VerifyWhatsAppWebhookParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyWhatsAppWebhook>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVerifyWhatsAppWebhookSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Ingestion sink (ADR-0015): a delivery whose X-Hub-Signature-256 verifies against the app secret is persisted verbatim, append-only, and acknowledged with 200; a processing job is enqueued in the same transaction (PRD Slice 5) — processing never runs inline, so the ack stays fast. A missing or tampered signature is rejected with 401 and persists nothing; an unconfigured webhook answers 503.
 * @summary Meta Cloud API webhook (group_* events)
 */
export const getReceiveWhatsAppDeliveryUrl = () => {


  

  return `/api/webhooks/whatsapp`
}

export const receiveWhatsAppDelivery = async ( options?: RequestInit): Promise<WhatsAppWebhookAck> => {
  
  return customFetch<WhatsAppWebhookAck>(getReceiveWhatsAppDeliveryUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getReceiveWhatsAppDeliveryMutationOptions = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveWhatsAppDelivery>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveWhatsAppDelivery>>, TError,void, TContext> => {

const mutationKey = ['receiveWhatsAppDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveWhatsAppDelivery>>, void> = () => {
          

          return  receiveWhatsAppDelivery(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceiveWhatsAppDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof receiveWhatsAppDelivery>>>
    
    export type ReceiveWhatsAppDeliveryMutationError = HttpError

    /**
 * @summary Meta Cloud API webhook (group_* events)
 */
export const useReceiveWhatsAppDelivery = <TError = HttpError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveWhatsAppDelivery>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receiveWhatsAppDelivery>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReceiveWhatsAppDeliveryMutationOptions(options), queryClient);
    }
    
